
//Helper function to create titles for statistics page
/**
 * @return {string}
 */
export function CreatePageName(statisticChoice){
    switch(statisticChoice){
        case 'pronunciationAssignments':
            return 'Pronunciation';
        case 'translationFCAssignments':
            return 'Translation Flash Cards';
        case 'dialogAssignments':
            return 'Dialog Practice';
        case 'dialogFCAssignments':
            return 'Dialog Flash Cards';
        case 'quizAssignments':
            return 'Translation Quiz';
        default:
            return ''
    }
}
